import React from 'react';

import { BoldText } from './AdditionalInfo.styled';
import { ContactPatientNavigatorLink } from 'screens/Book/components/ContactPatientNavigatorLink';

import { AdditionalInfoProps } from './AdditionalInfo.types';
import { AdditionalInfoProviderSearch } from './AdditionalInfoProviderSearch';
import { AdditionalInfoVirtual } from './AdditionalInfoVirtual';

export const AdditionalInfo = (props: AdditionalInfoProps): JSX.Element => {
  if (props.requiresPointerToDoctorPages) return <AdditionalInfoProviderSearch />;
  if (props.isVirtual) return <AdditionalInfoVirtual />;

  return (
    <>
      <BoldText>
        Do you need more immediate scheduling or need help booking with a specific provider?
      </BoldText>
      <br />
      <ContactPatientNavigatorLink /> or call <a href={`tel://855-563-2639`}>855-563-2639</a>
    </>
  );
};
